import styled from 'styled-components';

const VideoAnnotationsWrapper = styled.div`
  width: 100%;
  /* height: 30px; */
  position: relative;
  background-color: rgba(10,10,10,1);
  height: 26px;
  top: 0px;
`;
export default VideoAnnotationsWrapper;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoAnnotationWrapper.js